export default __webpack_public_path__ + "static/media/right_bcr.a1e07477.svg";